<tt-grid *ngIf="!!grid" [(ttOptions)]="grid" (ttOnRowSelected)="onRowSelected($event)" (ttRowDataChange)="onRowChanged($event)" (ttOnRead)="cdr.markForCheck()" (ttReady)="onGridReady()"></tt-grid>
